import * as React from 'react';
import 'antd/dist/antd.css';
import { NavigationItem, NavigationItemProps } from './NavigationItem';

export interface ProtectedNavigationItemProps extends NavigationItemProps {
  requiredRoles: string[];
  userRoles: string[];
  isLoggedIn: boolean;
}

export class ProtectedNavigationItem extends React.Component<ProtectedNavigationItemProps> {
  render() {
    const { requiredRoles, userRoles, isLoggedIn, ...restProps } = this.props;
    const hasRole = isLoggedIn && userRoles.filter((v) => requiredRoles.indexOf(v) !== -1).length > 0;
    return hasRole ? <NavigationItem {...restProps} /> : '';
  }
}
